import ActionTypes from "../const/ActionTypes"

export function showDrawingScreen () {
  return {
    type: ActionTypes.UI_DRAWING_SCREEN_SHOW
  }
}

export function showReplayerScreen () {
  return {
    type: ActionTypes.UI_REPLAY_SCREEN_SHOW
  }
}



// WEBPACK FOOTER //
// ./src/actions/ui.js